<template>
    <v-dialog
        v-model="showDialog"
        width="900"
    >
        <v-card v-if="data">
            <v-card-title style="background-color: #009688; color: white;">
                {{ data.RATE_TYPE === 'PACKAGE' ? 'PACKAGE' : 'DIAGNOSTIC' }} NAME: &nbsp;<v-chip>{{ data.DIA_T ? data.DIA_T : '' }}</v-chip>
                <v-spacer />
                <v-btn
                    color="success"
                    width="100"
                    @click="showAddLink"
                >
                    <v-icon small>
                        {{ mdiPlus }}
                    </v-icon>new
                </v-btn>&nbsp;
                <v-btn color="error" width="100" @click="showDialog = false">
                    <v-icon small>
                        {{ mdiClose }}
                    </v-icon>close
                </v-btn>
            </v-card-title>
            <v-data-table
                class="acuLinkTbl"
                :items="viewLinkedDiagRateData && viewLinkedDiagRateData.data ? viewLinkedDiagRateData.data : []"
                :headers="headers"
                :items-per-page="-1"
            >
                <template #item="{ item, index }">
                    <tr
                        @mouseenter="hoveredRow = index"
                        @mouseleave="hoveredRow = null"
                    >
                        <td
                            v-for="header in headers"
                            :key="header.value"
                            :style="{ backgroundColor: hoveredRow === index ? '#EEE' : 'white', textAlign: ['ACTIONS'].includes(header.value) ? 'center' : '' }"
                        >
                            <span style="text-wrap: nowrap;">
                                <template v-if="header.value === 'MODIFIED_DATE'">
                                    {{ formatDate(item.MODIFIED_DATE) }}
                                </template>
                                <template v-else-if="header.value === 'ACTIONS'">
                                    <!-- <v-tooltip top>
                                        <template #activator="{ on }">
                                            <v-btn
                                                icon
                                                color="primary"
                                                v-on="on"
                                                @click="showHistory(item)"
                                            >
                                                <v-icon>{{mdiEye}}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Show History</span>
                                    </v-tooltip> -->
                                    <!-- <v-tooltip top>
                                        <template #activator="{ on }">
                                            <v-btn
                                                icon
                                                color="warning"
                                                v-on="on"
                                                @click="editDiagnosticFunc(item)"
                                            >
                                                <v-icon>{{mdiPencil}}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit Diagnostic</span>
                                    </v-tooltip> -->
                                    <v-tooltip top>
                                        <template #activator="{ on }">
                                            <v-btn
                                                icon
                                                color="error"
                                                v-on="on"
                                                @click="showDeleteLink(item)"
                                            >
                                                <v-icon>{{ mdiTrashCan }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Delete Diagnostic</span>
                                    </v-tooltip>
                                </template>
                                <template v-else>
                                    {{ item[header.value] }}
                                </template>
                            </span>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <NewLink
            :show="showLink.add"
            :data="showLink.data"
            :rate-items="rateItems"
            :notif="notif"
            @refreshMsuRates="$emit('refreshMsuRates')"
            @closeDialog="showLink.add = false"
            @showIndexPage="showIndexPage"
        />
        <DeleteLink
            :show="showLink.delete"
            :data="showLink.data"
            :rate-items="rateItems"
            :notif="notif"
            @refreshMsuRates="$emit('refreshMsuRates')"
            @closeDialog="showLink.delete = false"
            @showIndexPage="showIndexPage"
        />
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DeleteLink from './DeleteLink.vue'
import NewLink from './NewLink.vue'
import {
    mdiPlus,
    mdiClose,
    mdiTrashCan
} from '@mdi/js'
import { moment } from '../../../../../../utils/date-shim'
export default {
    components: { NewLink, DeleteLink },
    props: ['show', 'data', 'rateItems', 'notif'],
    data: () => ({
        mdiPlus,
        mdiClose,
        mdiTrashCan,
        diagnosticName: null,
        hoveredRow: null,
        showLink: {
            add: false,
            edit: false,
            delete: false,
            data: null
        },
        headers: [
            { text: 'Diagnostic/Package Name', value: 'DIA_T' },
            // { text: 'ID', value: 'ID' },
            // { text: 'MSU_TYPE', value: 'MSU_TYPE' },
            // { text: 'Modified By', value: 'MODIFIED_BY' },
            // { text: 'Modified Date', value: 'MODIFIED_DATE' },
            { text: 'Actions', value: 'ACTIONS', align: 'center' }
        ]
    }),
    computed: {
        ...mapGetters(['viewLinkedDiagRateData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        async show(newVal) {
            if (newVal) {
                await this.viewLinkedDiagRate({ IS_LINKED_TO: this.data.ID, MSU_C: this.data.MSU_C })
            }
        }
    },
    methods: {
        ...mapActions(['viewLinkedDiagRate', 'getPackageDiagnostics']),
        showIndexPage(data) {
            if (!this.show) {
                this.$emit('showIndexPage', data)
            }
        },
        showDeleteLink(item) {
            let tempData = {
                ID: this.data.ID,
                UNLINK_FROM: item.ID,
                UNLINK_NAME: this.data.DIA_T,
                DIA_T: item.DIA_T,
                MSU_C: item.MSU_C,
                LINKS: this.data.LINKS
            }
            this.showLink.data = tempData
            this.showLink.delete = true
        },
        showAddLink() {
            this.showLink.data = this.data
            this.showLink.add = true
        },
        formatDate(date) {
            return moment(date).utcOffset('+0800').format('MMMM DD, YYYY hh:mm A')
        }
    }
}
</script>
